import SerialLabels from './serialLabels'

export default SerialLabels
